// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';
export const createStatusUpdate = createAction('status-updates/saga/create-status-update');
export const getStatusUpdates = createAction('status-updates/saga/get-status-updates');
export const putStatusUpdates = createAction('status-updates/saga/put-status-update');
export const updateStatusUpdateTitle = createAction('status-updates/saga/put-status-update-title');
export const deleteStatusUpdate = createAction('status-updates/saga/delete-status-update');
export const loadAllStatusUpdates = createAction('status-updates/saga/load--all-status-update');
export const loadStatusUpdates = createAction('status-updates/saga/load-status-update');
export const statusUpdatesLoadingState = createAction('status-updates/saga/status-update-loading-state');
